/**
 * Brand icons that lucide dropped in v1.
 *
 * lucide removed its brand/logo icons in 1.0 for trademark reasons. These are
 * rebuilt with lucide's own `createLucideIcon` factory using the original path
 * data from lucide-react 0.561.0 (ISC licensed), so they keep the exact
 * appearance and prop API (`size`, `strokeWidth`, `className`, `ref`) they had
 * before the upgrade.
 *
 * Note: the X (Twitter) mark in Footer.tsx is a hand-written inline SVG using
 * the real filled brand mark, because lucide never shipped one. If we ever want
 * all three socials to match that filled style, these two would be replaced the
 * same way rather than kept as lucide stroke outlines.
 */
import { createLucideIcon } from "lucide-react";

export const Linkedin = createLucideIcon("linkedin", [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f",
    },
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
]);

export const Youtube = createLucideIcon("youtube", [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4",
    },
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }],
]);
